import React, { Component, Fragment } from 'react';
import Avatar from '../../../../assets/images/avatar.jpg';

const MemberStatus = ({ status }) => {

    let statusText;
    let statusColor;

    switch (status) {
        case 'WORKING':
            statusText = 'Presente';
            statusColor = 'success';
            break;
        case 'OFF':
            statusText = 'Fora';
            statusColor = 'danger';
            break;
        default:
            statusText = 'Presente';
            statusColor = 'success';
    }
    return (
        <Fragment>
            <span class={`text-${statusColor} mr-1`}>●</span>
            <small>{statusText}</small>
        </Fragment>
    );
}

const TableRow = ({ dayName, opening, closing }) => (
    <tr>
        <th scope="row">{dayName}</th>
        <td>
            <i class="fas fa-arrow-up text-success mr-3" /> {opening}
        </td>
        <td>
            <i class="fas fa-arrow-down text-danger mr-3"></i> {closing}
        </td>
    </tr>
);

export default class Team extends Component {
    render() {
        return (
            <div class="card mb-5">
                <div class="card-header">
                    <h5 class="h3 mb-0">Horários de Funcionamento</h5>
                </div>
                <div class="table-responsive">
                    <table class="table align-items-center table-flush">
                        <thead class="thead-light">
                            <tr>
                                <th scope="col">Dia</th>
                                <th scope="col">Abertura</th>
                                <th scope="col">Fechamento</th>
                            </tr>
                        </thead>
                            <tbody>
                                <TableRow dayName="Segunda" opening="08h00m" closing="18h00m" />
                                <TableRow dayName="Terça" opening="08h0m" closing="18h00m" />
                                <TableRow dayName="Quarta" opening="08h0m" closing="18h00m" />
                                <TableRow dayName="Quinta" opening="08h0m" closing="18h00m" />
                                <TableRow dayName="Sexta" opening="08h0m" closing="18h00m" />
                                <TableRow dayName="Sábado" opening="08h0m" closing="12h00m" />
                            </tbody>
                        </table>
                    </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Pages/Establishment/OpeningHours/index.js